export function transparentize(hex: string, alpha?: number) {
  return hexToRGB(hex, alpha);
}

export function hexToRGB(hex: string, alpha?: number) {
  const color = hex.replace('#', '');
  const colorLength = color.length === 3 ? 1 : 2;
  const reg2 = new RegExp(`.{1,${colorLength}}`, 'g');
  // eslint-disable-next-line  @typescript-eslint/prefer-regexp-exec
  const colors = color.match(reg2) || [];
  const rgbString = colors.map(parseSingleHexColorToInt).join(', ');

  return hasAlpha(alpha) ? `rgba(${rgbString}, ${alpha})` : `rgb(${rgbString})`;
}

function parseSingleHexColorToInt(hexColor: string) {
  // because #fff === #ffffff
  const colorCode = hexColor.length === 2 ? hexColor : `${hexColor}${hexColor}`;

  return parseInt(colorCode, 16);
}

function hasAlpha(alpha?: number): alpha is number {
  return Boolean(alpha) || alpha === 0;
}
